export { default } from './symbol'
